import { render, staticRenderFns } from "./AdminShippingDetail.vue?vue&type=template&id=8cec2582&"
import script from "./AdminShippingDetail.vue?vue&type=script&lang=js&"
export * from "./AdminShippingDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminShippingDetail.vue?vue&type=style&index=0&id=8cec2582&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports